import React from "react";
import gears from "../../assets/images/gears.png";
import { LoggedInPageTemplate } from "../../core/layout/LoggedInPageTemplate"
import ActivateSerialCodeContainer from "./components/ActivateSerialCodeContainer";
import { strings } from "../../content/strings";

const ActivateSerialCodePage = () => {
    return (
        <LoggedInPageTemplate
            backgroundImage={gears}
            pageTitle={strings.activateSerialCodes}
            pageDescription=""
            pageCanonical="www.davincilock.com/SerialCodes_Locks/Redeem"
        >
            <ActivateSerialCodeContainer />
        </LoggedInPageTemplate >
    );
};

export default ActivateSerialCodePage;
